import { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import SettingsIcon from '@mui/icons-material/Settings';
import RackLifecycleModal from './RackLifecycleModal';

RackLifecycleButton.propTypes = {
  rackName: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object])),
    PropTypes.func,
    PropTypes.object
  ])
};

RackLifecycleButton.defaultProps = {
  rackName: '',
  color: 'primary',
  disabled: false
};

export default function RackLifecycleButton({ rackName, color, disabled, sx = [] }) {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <>
      <IconButton
        data-testid="rack-lifecycle-button"
        onClick={openModal}
        sx={{ ...sx }}
        disabled={disabled}
        color={color}
        aria-label="Lifecycle"
      >
        <SettingsIcon />
      </IconButton>

      <RackLifecycleModal isOpen={modalOpen} closeHandler={closeModal} rackName={rackName} />
    </>
  );
}
